import React from "react";
import { Col, Button } from "antd";
import { TitleContainer } from "./elements";


interface TableTitleProps {
  setShowEmailsModal: (value: boolean) => void;
}

const TableTitle: React.FC<TableTitleProps> = ({
  setShowEmailsModal,
}) => {
  return (
    <div>
      <TitleContainer>
        <Col
          span={24}
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex",
            gap: "10px",
            flexGrow: 1 }}>
          </div>
          <div style={{ marginLeft: "auto" }}>
            <Button
              type="primary"
              onClick={() => setShowEmailsModal(true)}
            >
              Ver Correos
            </Button>
          </div>
        </Col>
      </TitleContainer>
    </div>
  );
};

export default TableTitle;
